'use client'
import styled from '@emotion/styled'
import { ReactNode } from 'react'
import { ResponsivePadding } from './ResponsivePadding'
import Link from 'next/link'

const Container = styled.div<{ contrast: boolean }>`
  ${ResponsivePadding};

  margin-top: 6rem;
  width: 100%;

  background-color: ${({ theme, contrast }) => (contrast ? theme.onBackground : theme.background)};
  border-bottom: 1px solid ${({ theme }) => theme.onBackgroundLightest};

  padding-bottom: 5rem;
  padding-top: 4rem;

  color: ${({ theme, contrast }) => (contrast ? theme.background : theme.onBackground)};

  > h1 {
    margin-top: 1rem;
    font-size: 4rem;
    font-weight: 600;
    width: 70%;
    padding-right: 2rem;

    @media (max-width: 800px) {
      width: 100%;
      font-size: 3rem;
    }

    @media (max-width: 500px) {
      font-size: 2.5rem;
    }
  }

  > p {
    margin-top: 1rem;
    font-size: 1.25rem;

    max-width: 40rem;
  }

  .label {
    display: inline-block;
    background-color: ${({ theme }) => theme.primaryLighter};
    color: ${({ theme }) => theme.primary};

    padding: 0.25rem 0.5rem;
    border-radius: 0.25rem;
    font-size: 1.05rem;
  }

  .icon {
    font-size: 3rem;
    color: ${({ theme }) => theme.primary};
    background-color: ${({ theme }) => theme.primaryLighter};
    padding: 0.5rem;

    border-radius: 0.25rem;
  }

  a {
    display: block;

    color: ${({ theme }) => theme.onBackgroundLight};
    :hover {
      color: ${({ theme }) => theme.primaryLight};
    }
      
    text-decoration: none;
    font-size: 1rem;

    margin-bottom: 3rem;
  }
`

interface Props {
  label?: string
  icon?: ReactNode
  title: string
  body: string
  backHome?: boolean
  contrast?: boolean
  children?: ReactNode
}

export const HeaderSection = ({ backHome, label, icon, title, body, contrast = false, children }: Props) => {
  return (
    <Container contrast={contrast}>
      {backHome && <Link href="/">← Tillbaka till startsidan</Link>}
      {icon}
      {label && <span className="label">{label}</span>}
      <h1>{title}</h1>
      <p>{body}</p>
      {children}
    </Container>
  )
}
